import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=116732d0&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116732d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('116732d0')) {
      api.createRecord('116732d0', component.options)
    } else {
      api.reload('116732d0', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=116732d0&scoped=true&", function () {
      api.rerender('116732d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/jyutyu/detail.vue"
export default component.exports